module.exports = __webpack_public_path__ + "img/kv-pc.fa2f39a.webp";